"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DiscountController_js_1 = require("./DiscountController.js");
exports.DiscountController = DiscountController_js_1.DiscountController;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/discount/controllers/index.ts
// module id = 396
// module chunks = 0